<template>
  <div class="Child">
    <vxe-toolbar fixed="top">
      <template v-slot:buttons>
        <el-button
          @click="
            listQuery.pageNum - 1;
            shipmentlist();
          "
        >
          查询
        </el-button>
        <el-button @click="clearRadioRowEevnt"> 取消选中 </el-button>
        <el-button type="primary" @click="getRadioEvent"> 获取选中 </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable1"
      height="500"
      border
      :loading="loading"
      :radio-config="{ highlight: true }"
      :data="tableData"
      @radio-change="radioChangeEvent"
    >
      <vxe-table-column type="radio" width="60" />

      <vxe-table-column>
        <vxe-table-column
          field="partyType"
          :formatter="formatterpartyType"
          min-width="100"
          title="类型"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.partyType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="name" min-width="100" title="名称" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="phone" min-width="150" title="联系电话" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { partyBalanceStatistics } from "@/api/collectioncoding";
export default {
  name: "Child",
  data() {
    return {
      loading: false,
      getdata: [],
      listQuery: {
        name: "",
        phone: "",
        partyType: "",
        createdBy: "",
        gmtCreated: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        branchCode: this.$store.state.user.party.branchCode
      },
      Pagingconf: [],
      tableData: [],
      options: [
        {
          value: "PLAT",
          label: "平台"
        },
        {
          value: "SHIPMENT",
          label: "托运人"
        }
      ]
    };
  },
  created() {
    this.shipmentlist();
  },
  methods: {
    //查询收款方
    shipmentlist() {
      this.loading = true;
      partyBalanceStatistics(this.listQuery).then(response => {
        this.tableData = response.data.records;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
        this.listQuery.total = response.data.total;
        this.loading = false;
      });
    },
    //获取选中
    getRadioEvent() {
      this.getdata = this.$refs.xTable1.getRadioRecord();
      if (!this.getdata) {
        this.$message({ message: "请选择付款方", type: "warning" });
        return false;
      }
      this.$emit("event1", this.getdata);
    },
    //取消选中
    clearRadioRowEevnt() {
      this.selectRow = null;
      this.$refs.xTable1.clearRadioRow();
    },
    //选中事件
    radioChangeEvent({ row }) {
      this.selectRow = row;
    },
    // 查询
    funcFilter() {
      this.listQuery.pageNum = 1;
      this.shipmentlist();
    },
    formatterpartyType({ cellValue }) {
      switch (cellValue) {
        case "PLAT":
          return "平台";
        case "SHIPMENT":
          return "托运人";
        default:
          break;
      }
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.shipmentlist();
    }
  }
};
</script>
